// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Svg, exists} from '@pub/comp/svg';
import * as cns from './icon.module.less';

const SIZE_MAP = {
    // mini: 12,
    // tiny: 16,
    // small: 18,
    // medium: 20,
    // regular: 24,
    // big: 30,
    // large: 36,
    // xl: 48,
    xxs: 12,
    xs: 16,
    s: 18,
    m: 20,
    l: 24,
    xl: 28,
    xxl: 32,
};

export function Icon({
    className,
    name,
    alt,
    size='m',
    color='main',
    tooltip_text,
    tooltip_placement,
})
{
    const color_cn = cns[`color_${color}`];
    if (!color_cn)
        throw new Error(`Icon: unknown color ${color}`);
    return <Svg className={cn(color_cn, className)} name={name}
      alt={alt} as="span" size={SIZE_MAP[size] || size}
      tooltip_text={tooltip_text} tooltip_placement={tooltip_placement}/>;
}

export {exists};
